import { render } from "./ViewPlayBookCardItem.vue?vue&type=template&id=62534667&ts=true"
import script from "./ViewPlayBookCardItem.vue?vue&type=script&lang=ts"
export * from "./ViewPlayBookCardItem.vue?vue&type=script&lang=ts"

import "./ViewPlayBookCardItem.vue?vue&type=style&index=0&id=62534667&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__